import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getInvestorApiUrl } from "../../utils/config";
import { ApiRequestParams, handleFetchApi } from "../../utils/api";

// Initial state for the account slice
const initialState = {
  linkToken: null,  // To store the POST API response for file upload
  loading: false,        // To track loading state
  error: "",
  linkAccountdata: "",            // To track any errors
};

export const linkAccount = createAsyncThunk(
  "account/linkAccount",
  async (payload, thunkApi) => {
    try {
      const params: ApiRequestParams = {
        method: "POST",
        baseUrl: getInvestorApiUrl(),
        endpoint: "LinkAccount",
        payload
      }
      const response = await handleFetchApi(params);
      // const response = await axios.post(
      //   `${baseUrl}/LinkAccount`,
      //   payload, // Send payload as JSON
      //   {
      //     headers: {
      //       'Content-Type': 'application/json', // Set the content type to JSON
      //     },
      //   }
      // );

      return response.data; // Return API response
    } catch (error:any) {
      return thunkApi.rejectWithValue(
        error.response?.data || "Failed to link account"
      );
    }
  }
);

export const completeAuction = createAsyncThunk(
  "account/completeAuction",
  async (investorId:any, thunkApi) => {
    try {
      const params: ApiRequestParams = {
        method: "GET",
        baseUrl: getInvestorApiUrl(),
        endpoint: `auction/investor/${investorId}`,
      }
      const response = await handleFetchApi(params);
      return response.data; // Return API response
    } catch (error:any) {
      return thunkApi.rejectWithValue(
        error.response?.data || "Failed to link account"
      );
    }
  }
);


const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(linkAccount.pending, (state) => {
        state.loading = true;
        state.linkAccountdata = "";
      })
      .addCase(linkAccount.fulfilled, (state, action) => {
        state.loading = false;
        state.linkAccountdata = action.payload;
      })
      .addCase(linkAccount.rejected, (state, action:any) => {
        state.loading = false;
        state.error = action.payload || "Failed to link account";
      });
  },
});

export default accountSlice.reducer;
